import React from "react";
import ReactDOM from "react-dom/client";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import "@/index.css";
import App from "@/App";

// The Cal.com embed script raises an opaque cross-origin "Script error." that is not
// actionable. Keep it out of the console and out of the CRA dev error overlay.
window.addEventListener(
  "error",
  (e) => {
    if (!e.message || e.message === "Script error.") {
      e.stopImmediatePropagation();
      e.preventDefault();
    }
  },
  true,
);

if (process.env.NODE_ENV === "development") {
  import("react-error-overlay").then((overlay) => overlay.stopReportingRuntimeErrors()).catch(() => {});
  // webpack-dev-server v4 renders its own full-screen overlay iframe; remove it on sight.
  new MutationObserver(() => {
    document.getElementById("webpack-dev-server-client-overlay")?.remove();
  }).observe(document.documentElement, { childList: true, subtree: true });
}

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      refetchOnWindowFocus: false,
    },
  },
});

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </React.StrictMode>,
);
